module.exports = __webpack_public_path__ + "img/h4.fbf21654.jpg";